export default __webpack_public_path__ + "fde8ec9.png";